"use client";

import { Button } from "@/components/ui/button";
import {
	Card,
	CardContent,
	CardFooter,
	CardHeader,
	CardTitle,
} from "@/components/ui/card";
import { cn } from "@/lib/utils";
import { CircleCheckBigIcon } from "lucide-react";
import { useState } from "react";
import VerifyOtpForm from "./verify-otp-form";

interface SignInSuccessProps {
	email?: string;
	className?: string;
}

export default function SignInSuccess({
	email,
	className,
}: SignInSuccessProps) {
	const [enterCode, setEnterCode] = useState(false);

	if (enterCode) {
		return <VerifyOtpForm type="email" email={email} />;
	}

	return (
		<Card className={cn("bg-transparent border-none shadow-none", className)}>
			<CardHeader className="items-center justify-center text-center space-y-4">
				<CircleCheckBigIcon className="w-12 h-12 text-green-500" />
				<CardTitle className="text-3xl font-extrabold tracking-tighter">
					Please check your email
				</CardTitle>
			</CardHeader>
			<CardContent>
				<p className="text-md text-primary-64 text-center">
					We have sent a login link to your email account{" "}
					<span className="font-semibold text-primary">{email}</span>. Please
					check your email to login.
				</p>
			</CardContent>
			<CardFooter>
				<Button
					variant="outline"
					className="w-full rounded-full"
					onClick={() => setEnterCode(true)}
				>
					Have a verification code?
				</Button>
			</CardFooter>
		</Card>
	);
}
